import React from 'react'

const Loader = ({ size = 'sm', color = '#1d67aa' }) => {
  const sizeClasses = {
    xs: 'spinner-border-sm',
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border-lg'
  }

  const sizeStyles = {
    xs: { width: '12px', height: '12px' },
    sm: { width: '16px', height: '16px' },
    md: { width: '24px', height: '24px' },
    lg: { width: '32px', height: '32px' }
  }

  return (
    <div 
      className={`spinner-border ${sizeClasses[size]}`} 
      role="status"
      style={{ 
        color: color,
        ...sizeStyles[size]
      }}
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}

export default Loader